"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var FormInputLabel = function (props) {
    return ((props === null || props === void 0 ? void 0 : props.label) && ((0, jsx_runtime_1.jsxs)("p", { className: "apx-ui_form--label ".concat(props.labelClassName), children: [props.label, ' ', props.required ? (0, jsx_runtime_1.jsx)("span", { style: { color: 'red' }, children: "*" }) : ''] })));
};
exports.default = FormInputLabel;
